<template>
  <div class="custom-overlay-container">
    <div v-show="open" class="custom-overlay" :class="{ open }"></div>
    <div class="overlay-container" :class="{ open }">
      <div class="overlay-box">
        <!-- 우편번호 검색 기능 -->
        <div class="window-wrap" id="window-wrap">
          <div
            id="wrap"
            style="display: none; border: 3px solid black; width: 300px; height: 400px; margin: 5px 0; position: relative; max-height: 400px"
          >
            <img
              src="//t1.daumcdn.net/postcode/resource/images/close.png"
              id="btnCloseLayer"
              style="cursor: pointer; position: absolute; right: -3px; top: -3px; z-index: 1"
              @click="closePostcode"
              alt="닫기 버튼"
            />
          </div>
        </div>
        <!-- 주문 목록보기/ 주문 상세/ 배송지변경  -->
        <div class="overlay-wrapper">
          <div class="overlay-header">
            <div class="overlay-header-text">
              <h3>{{ title }}</h3>
              <a class="overlay-header-close-icon">
                <i class="UXicon-close" @click="onConsultStart('none')"></i>
              </a>
            </div>
            <div class="overlay-header-line"></div>
          </div>
          <div class="overlay-content">
            <div v-if="step === 1">
              <!-- 주문 목록 표시 -->
              <div v-for="(order, index) in orderListData" :key="index">
                <div class="overlay-item-wrapper">
                  <div class="overlay-item-title">
                    <h3>{{ getOrderData(order.order_date) }} 주문</h3>
                    <span> {{ order.order_id }}</span>
                  </div>
                  <div v-for="(item, index) in order.items" :key="index">
                    <div class="overlay-item-content">
                      <div class="content-img" :class="[cafe24ProdBoxImgBox, { defaultImg: !(item.originProduct && item.originProduct.list_image) }]">
                        <img
                          v-if="item.originProduct && item.originProduct.list_image"
                          :src="`${item.originProduct.list_image}`"
                          style="width: 60px; height: 60px; border: 1px solid #dbdade; border-radius: 5px"
                          @error="imgUpdate(true)"
                        />
                      </div>
                      <div class="overlay-item-desc">
                        <p>
                          <b :style="{ color: '#5578F0' }">{{ getShippingStatus('order_status', item.order_status) }}</b>
                        </p>
                        <p>
                          <b>{{ item.product_name }}</b>
                        </p>
                        <p>{{ removeDecimal(item.product_price) }}원 / {{ getOption(item.options) }} {{ item.quantity }}개</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="overlay-flex">
                  <DesignButton text="주문 상세" size="x-large" @click="nextStep(order)" />
                </div>
              </div>
            </div>
            <div v-if="step === 2">
              <!-- 주문 상품 상세 표시 -->
              <div v-show="hasGuide" class="overlay-top-guide">
                <span>{{ guideText3 }}</span>
              </div>
              <div class="overlay-item-wrapper">
                <div class="overlay-item-title">
                  <div>
                    <DesignCheckbox :value="isAllChecked" @input="toggleAll" :indeterminate="isIndeterminate" size="small" />
                  </div>
                  <h3 class="h3-checkbox-with">{{ getOrderData(orderDetailData.order_date) }} 주문</h3>
                  <span> {{ orderDetailData.order_id }}</span>
                </div>
                <div v-for="(item, index) in orderDetailData.items" :key="index">
                  <div class="overlay-item-content">
                    <div class="content-img" :class="[cafe24ProdBoxImgBox, { defaultImg: !(item.originProduct && item.originProduct.list_image) }]">
                      <img
                        v-if="item.originProduct && item.originProduct.list_image"
                        :src="`${item.originProduct.list_image}`"
                        @error="imgUpdate(true)"
                      />
                    </div>
                    <div class="overlay-item-checkbox">
                      <DesignCheckbox
                        :value="selectedItems.includes(item.order_item_code)"
                        @input="(checked) => toggleItem(item.order_item_code, checked)"
                        size="small"
                      />
                    </div>
                    <div class="overlay-item-desc overlay-item-desc-with-checkbox">
                      <p>
                        <b :style="{ color: '#5578F0' }">{{ getShippingStatus('order_status', item.order_status) }}</b>
                      </p>
                      <p>
                        <b>{{ item.product_name }}</b>
                      </p>
                      <p>{{ removeDecimal(item.product_price) }}원 / {{ getOption(item.options) }} {{ item.quantity }}개</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 주문 정보 상세 그룹아래 배송정보 조회 버튼 -->
              <!-- <div>
                <DesignButton text="배송 조회" color="primary" @click="nextStep(orderDetailData.items)" />
              </div> -->
            </div>

            <!-- 구매자 정보, 결제 정보, 배송지 정보 -->
            <div class="overlay-order-info-container" v-if="step === 2">
              <div class="overlay-order-info">
                <span class="info-title">구매자 정보</span>
                <div class="info-row">
                  <div class="info-head">주문자</div>
                  <div class="info-content">{{ orderDetailData.buyer.name }}</div>
                </div>
                <div class="info-row">
                  <div class="info-head">이메일 주소</div>
                  <div class="info-content">{{ orderDetailData.buyer.email }}</div>
                </div>
                <div class="info-row">
                  <div class="info-head">휴대폰 번호</div>
                  <div class="info-content">{{ orderDetailData.buyer.cellphone }}</div>
                </div>
              </div>

              <div class="overlay-order-info">
                <span class="info-title">결제 정보</span>
                <div class="info-row">
                  <div class="info-head">결제 수단</div>
                  <div class="info-content">{{ getShippingStatus('payment_method', orderDetailData.payment_method) }}</div>
                </div>
                <div class="info-row">
                  <div class="info-head">결제 상태</div>
                  <div class="info-content">{{ getShippingStatus('paid', orderDetailData.paid) }}</div>
                </div>
                <div class="info-row">
                  <div class="info-head">결제 일시</div>
                  <div class="info-content">{{ orderDetailData.payment_date ? getOrderData(orderDetailData.payment_date) : '-' }}</div>
                </div>
                <div class="info-row">
                  <div class="info-head">상품 금액</div>
                  <div class="info-content">{{ removeDecimal(orderDetailData.initial_order_amount.order_Price_Amount) }} 원</div>
                </div>
                <div class="info-row">
                  <div class="info-head">배송비</div>
                  <div class="info-content">{{ removeDecimal(orderDetailData.initial_order_amount.shipping_fee) }} 원</div>
                </div>
                <div class="info-row">
                  <div class="info-head">쿠폰 할인</div>
                  <div class="info-content">{{ removeDecimal(orderDetailData.initial_order_amount.coupon_discount_price) }} 원</div>
                </div>
                <div class="info-row">
                  <div class="info-head">적립금 사용</div>
                  <div class="info-content">{{ removeDecimal(orderDetailData.initial_order_amount.credits_spent_amount) }} 원</div>
                </div>
                <div class="info-row">
                  <div class="info-head">총 결제 금액</div>
                  <div class="info-content" :style="{ color: '#5578F0' }">
                    {{ removeDecimal(orderDetailData.initial_order_amount.payment_amount) }} 원
                  </div>
                </div>
              </div>

              <!-- 주문에서 취소나, 환불 요청이 있는 경우 해당 정보 노출조건 추가 -->
              <div class="overlay-order-info" v-if="orderDetailData.initial_order_amount.app_discount_amount > 0">
                <span class="info-title">취소/환불 정보</span>
                <div class="info-row">
                  <div class="info-head">총 환불 금액</div>
                  <div class="info-content" :style="{ color: '#EA5455' }">
                    {{ removeDecimal(orderDetailData.initial_order_amount.app_discount_amount) }} 원
                  </div>
                </div>
              </div>

              <div class="overlay-order-info">
                <span class="info-title">배송지 정보</span>
                <div class="info-row">
                  <div class="info-head">받는 사람</div>
                  <div class="info-content">{{ orderDetailData.receivers[0].name ? orderDetailData.receivers[0].name : '-' }}</div>
                </div>
                <div class="info-row">
                  <div class="info-head">휴대폰 번호</div>
                  <div class="info-content">{{ orderDetailData.receivers[0].cellphone ? orderDetailData.receivers[0].cellphone : '-' }}</div>
                </div>
                <div class="info-row">
                  <div class="info-head">주소</div>
                  <div class="info-content">
                    <div v-if="!updateAddress">{{ orderDetailData.receivers[0].address1 }} {{ orderDetailData.receivers[0].address2 }}</div>
                    <div v-else class="info-content-update">
                      <div class="overlay-flex flex-1">
                        <DesignInput v-model="postcodeInfo.zonecode" />
                        <DesignButton text="우편번호 검색" @click="updateShippingAddress" />
                      </div>
                      <DesignInput v-model="postcodeInfo.address" />
                      <DesignInput v-model="postcodeInfo.detailAddress" />
                    </div>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-head">배송요청사항</div>
                  <div class="info-content">
                    <div v-if="updateAddress">
                      <DesignInput v-model="postcodeInfo.request" />
                    </div>
                    <div v-else>{{ orderDetailData.receivers[0].shipping_message ? orderDetailData.receivers[0].shipping_message : '-' }}</div>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-head">송장 번호</div>
                  <div class="info-content">
                    {{ orderDetailData.supplier_name ? orderDetailData.supplier_name : '' }}
                    <span :style="{ color: '#5578F0' }">{{ orderDetailData.tracking_no ? orderDetailData.tracking_no : '-' }} </span>
                  </div>
                </div>
                <!-- <div v-if="status === '배송전' && !updateAddress">
                  <DesignButton text="배송지 변경" @click="updateShippingAddress" />
                </div>
                <div v-else class="info-content-update-button">
                  <DesignButton text="취소" size="small" @click="updateAddress = false" />
                  <DesignButton text="저장" size="small" color="primary" />
                </div> -->
              </div>
            </div>

            <!-- 주문상세 배송조회 -->
            <div v-if="step === 3">
              <div class="overlay-item-wrapper">
                <div class="overlay-item-content">
                  <div class="content-img" :class="[cafe24ProdBoxImgBox, { defaultImg: !(item.originProduct && item.originProduct.listImage) }]">
                    <img
                      v-if="item.originProduct && item.originProduct.list_image"
                      :src="`${item.originProduct.list_image}`"
                      @error="imgUpdate(true)"
                    />
                  </div>
                  <div class="overlay-item-desc">
                    <div class="overlay-item-desc">
                      <p><b :style="{ color: '#5578F0' }">배송중</b></p>
                      <p><b>여성용 화이트 티셔츠</b></p>
                      <p>25,600원 / M / 1개</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="overlay-item-wrapper-v2">
                <div class="overlay-item-delivery-box">
                  <h3>택배 회사명</h3>
                  <p>현재 주문하신 상품은 배송 중입니다. 상품의 이동 상황은 송장번호를 통해 해당 택배사 시스템에서 확인하실 수 있습니다.</p>
                  <div class="overlay-item-delivery-box-tracking">
                    <div>
                      <b>송장번호</b>: <b :style="{ color: '#5578F0' }">{{ orderDetailData.tracking_no }}</b>
                    </div>
                    <div class="overlay-flex">
                      <i class="UXicon-copy_outlined" @click="copy(orderDetailData.tracking_no)"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="overlay-item-wrapper-v2">
                <DesignButton color="green" text="송장번호 조회하기" @click="loadTrackingNumber" />
              </div>
            </div>

            <div v-show="hasGuide" class="overlay-buttom-guide">
              <i class="UXicon-info"></i>
              <span>{{ step === 1 ? guideText1 : guideText2 }}</span>
            </div>
            <div class="overlay-footer" v-if="step !== 1">
              <DesignButton v-if="step === 2 || step === 3" text="이전 단계" fullWidth @click="prevStep" />
              <DesignButton v-if="step !== 1" text="이전 채팅" fullWidth color="primary" @click="onConsultStart('none')" />
              <DesignButton
                v-if="step !== 1"
                text="전문 상담 시작"
                fullWidth
                color="primary"
                :disabled="selectedItems.length === 0"
                @click="onConsultStart('consult')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DesignButton from '@/components/DesignButton';
import DesignCheckbox from '@/components/DesignCheckbox';
import DesignRadioButton from '@/components/DesignRadioButton';
import DesignInput from '@/components/DesignInput';
import { getCafe24CodeStatus } from '@/constants/cafe24CodeInfo';
import moment from 'moment';

export default {
  name: 'BottomSheet',
  props: {
    open: {
      type: Boolean,
      default: false,
      required: false
    },
    orderData: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  components: {
    DesignButton,
    DesignCheckbox,
    DesignRadioButton,
    DesignInput
  },
  data() {
    return {
      title: '주문 목록',
      step: 1,
      hasGuide: true,
      guideText1: '최근 1개월 이내의 주문만 표시됩니다. 이전 주문은 사이트에서 확인해주세요.',
      guideText2: '표시된 결제 정보는 쇼핑몰 시스템과 일부 다를 수 있습니다. 정확한 내역은 해당 사이트에서 확인 부탁드립니다.',
      guideText3: '정확한 상담을 위해, 주문 내역에서 문의하실 상품을 선택해 주세요.',
      postcodeInfo: {
        zonecode: '',
        address: '',
        detailAddress: '',
        request: '택배보관함에 놔주세요'
      },
      updateAddress: false,
      diliverySearchData: [],

      orderListData: [],
      orderDetailData: {},
      selectedItems: [],
      cafe24ProdBoxImgBox: 'img'
    };
  },
  computed: {
    isAllChecked() {
      return this.selectedItems.length === this.orderDetailData.items.length && this.orderDetailData.items.length > 0;
    },
    isIndeterminate() {
      return this.selectedItems.length > 0 && this.selectedItems.length < this.orderDetailData.items.length;
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.step = 1;
        this.title = '주문 목록';
      }
    },
    orderData(val) {
      this.orderListData = val;
    }
  },
  mounted() {
    if (!window.daum || !window.daum.Postcode) {
      const script = document.createElement('script');
      script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      document.head.appendChild(script);
    }
  },
  created() {},
  methods: {
    closePostcode() {
      const elementWrap = document.getElementById('wrap');
      const windowWrap = document.getElementById('window-wrap');
      this.orderListData = [];

      windowWrap.style.display = 'none';
      elementWrap.style.display = 'none';
    },
    updateShippingAddress() {
      const elementWrap = document.getElementById('wrap');
      const windowWrap = document.getElementById('window-wrap');

      new window.daum.Postcode({
        oncomplete: (data) => {
          this.updateAddress = true;
          this.postcodeInfo.zonecode = data.zonecode;
          this.postcodeInfo.address = data.address;
        },
        onresize: function (size) {
          elementWrap.style.height = size.height + 'px';
        },
        onclose: function () {
          windowWrap.style.display = 'none';
          elementWrap.style.display = 'none';
        },
        width: '100%',
        height: '100%',
        zIndex: 10000
      }).embed(elementWrap);

      // iframe을 넣은 element를 보이게 한다.
      elementWrap.style.display = 'block';
      windowWrap.style.display = 'flex';
    },
    copy(number) {
      navigator.clipboard.writeText(number);
    },
    loadTrackingNumber() {
      this.$mitt.emit('DialogPopup', {
        useDialog: true,
        getBtnCount: 2,
        useDesignPopup: true,
        getBtnName: '이동',
        message: '네이버 택배 배송 조회 페이지로 이동합니다.<br/>송장번호를 입력해 현재 배송 상태를 확인해보세요. 조회 화면은 새 창으로 열립니다.',
        getButtonEvent: () => {
          window.open('https://search.naver.com/search.naver?query=배송조회', '_blank');
        }
      });
    },
    requestCancel() {
      this.$mitt.emit('DialogPopup', {
        useDialog: true,
        getBtnCount: 2,
        useDesignPopup: true,
        message: '주문을 취소하시겠어요?'
      });
    },
    prevStep() {
      if (this.step === 2) {
        this.step = 1;
        this.title = '주문 목록';
        this.hasGuide = true;
        this.guideText = '최근 1개월 이내의 주문만 표시됩니다. 이전 주문은 사이트에서 확인해주세요.';
        this.orderDetailData = [];
        this.selectedItems = [];
      } else if (this.step === 3) {
        this.step = 2;
        this.title = '주문 상세';
        this.hasGuide = true;
        this.guideText = '주문이 보이지 않으시나요? 더 많은 주문 내역은 사이트에서 확인해주세요.';
      }
    },
    nextStep(order) {
      if (this.step === 1) {
        this.step = 2;
        this.title = '주문 상세';
        this.hasGuide = true;
        this.guideText = '주문이 보이지 않으시나요? 더 많은 주문 내역은 사이트에서 확인해주세요.';
        this.orderDetailData = order;
        this.selectedItems = [];
      } else if (this.step === 2) {
        this.step = 3;
        this.title = '배송 조회';
        this.hasGuide = false;
        this.diliverySearchData = order;
      }
    },
    getOrderData(val) {
      let formatTime = 'YYYY-MM-DD';
      return moment(`${val} +0000`, 'YYYYMMDDHHmmss Z').format(formatTime);
    },
    getShippingStatus(key, val) {
      return getCafe24CodeStatus(key, val);
    },
    removeDecimal(value) {
      if (!value) return ' 0 ';
      let intPart = value.includes('.') ? value.split('.')[0] : value;
      // 3자리마다 콤마 넣기
      return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getOption(items) {
      if (!items) return ' - / ';

      const array = Array.isArray(items) ? items : [];
      let optionString = '';

      array.forEach((option) => {
        const text = option?.option_value?.option_text;
        if (text) {
          optionString += `${text} / `;
        }
      });

      return optionString;
    },
    toggleAll(checked) {
      this.selectedItems = checked ? this.orderDetailData.items.map((item) => item.order_item_code) : [];
    },
    toggleItem(id, checked) {
      if (checked) {
        if (!this.selectedItems.includes(id)) {
          this.selectedItems.push(id);
        }
      } else {
        this.selectedItems = this.selectedItems.filter((itemId) => itemId !== id);
      }
    },
    imgUpdate(showDefaultImg = false) {
      if (showDefaultImg) {
        this.cafe24ProdBoxImgBox = 'img defaultImg';
      }
    },
    onConsultStart(type) {
      let data = {
        type: type,
        sendText: ''
      };

      if (type === 'none') {
        this.$emit('handleClose', data);
        return;
      }

      let detailText = this.orderDetailData.items
        .filter((item) => this.selectedItems.includes(item.order_item_code))
        .map((item) => {
          return `\n\n${item.product_name}\n${this.removeDecimal(item.product_price)}원/ ${this.getOption(item.options)} ${item.quantity}개`;
        })
        .join('');
      data.sendText = `주문번호 : ${this.orderDetailData.order_id}` + detailText;

      this.closePostcode();
      this.$emit('handleClose', data);
    }
  }
};
</script>
<style scoped lang="scss">
.custom-overlay-container {
  .overlay-flex {
    display: flex;
    align-items: center;
    &.flex-1 {
      .design-input-container {
        flex: 1;
      }
    }
  }
  .custom-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000; /* 오버레이가 다른 내용 위에 표시되도록 설정 */
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    &.open {
      opacity: 1;
    }
    &.top {
      z-index: 2002;
    }
  }

  .custom-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3003;
    height: 200px;
    background-color: white;
  }

  .overlay-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2001;
    transition: transform 0.3s ease-in-out;
    transform: translateY(100%);
    &.open {
      transform: translateY(0%);
    }
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    &.top {
      z-index: 2003;
    }
    .overlay-box {
      position: fixed;
      bottom: 0;
      z-index: 1000;
      height: calc(100% - 100px);
      border-radius: 30px 30px 0 0;
      background-color: white;
      width: 410px;
      .window-wrap {
        display: none;
        justify-content: center;
        align-items: center;
        position: fixed;
        width: 410px;
        height: 100%;

        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2000;
        transition: opacity 0.3s ease-in-out;
        border-radius: 30px;
      }
      .overlay-wrapper {
        display: flex;
        flex-direction: column;
        height: 100%;
        .overlay-header {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-bottom: 0;
          .overlay-header-close-icon {
            position: absolute;
            right: 20px;
            i {
              color: #676767;
              cursor: pointer;
            }
          }
          .overlay-header-text {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 17.5px 16px;
            padding-bottom: 0;
            color: #2a2a2a;
          }
          .overlay-header-line {
            padding-top: 17.5px;
            border-bottom: 1px solid #ececee;
          }
        }

        .overlay-content {
          overflow: auto;
          padding-bottom: 76px;
          /* Webkit 기반 브라우저 (Chrome, Edge, Safari 등) */
          &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }

          &::-webkit-scrollbar-thumb {
            background-color: rgba(121, 84, 84, 0.2);
            border-radius: 4px;
            transition: background-color 0.3s;
          }

          &::-webkit-scrollbar-thumb:hover {
            background-color: rgba(0, 0, 0, 0.4);
          }
        }
        .overlay-top-guide {
          display: flex;
          align-items: center;
          margin: 20px 20px 0px 20px;
          padding: 20px 18px;
          height: 42px;
          padding-bottom: 20px;
          background-color: #eeeeef;
          border-radius: 10px;
          span {
            margin-left: 5px;
            font-size: 12px;
            line-height: 100%;
            font-weight: 400;
            color: #676767;
          }
        }
        .overlay-order-info {
          padding: 20px;
          display: flex;
          flex-direction: column;
          font-size: 12px;
          color: #676767;
          gap: 10px;

          .info-title {
            font-size: 14px;
            line-height: 20px;
            font-weight: 700;
          }

          .info-row {
            display: flex;
          }

          .info-head {
            width: 80px;
            flex-shrink: 0;
          }

          .info-content {
            font-weight: 700;
            flex: 1;
            .overlay-flex {
              gap: 10px;
            }
            .info-content-update {
              display: flex;
              flex-direction: column;
              gap: 6px;
            }
          }
          .info-content-update-button {
            display: flex;
            gap: 6px;
            justify-content: flex-end;
          }
        }

        .overlay-item-wrapper-v2 {
          padding: 20px;
          padding-top: 0;
          font-size: 12px;
          line-height: 16px;
        }
        .overlay-item-delivery-box {
          display: flex;
          background-color: #eeeeef;
          padding: 14px 20px;
          border-radius: 10px;
          flex-direction: column;
          gap: 6px;
          p {
            color: '#676767';
          }
          i {
            font-size: 20px;
            color: #919191;
            cursor: pointer;
          }

          .overlay-item-delivery-box-tracking {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
        .overlay-item-wrapper {
          padding: 20px 20px 10px 20px;
          font-size: 12px;
          line-height: 16px;
          position: relative;
          input[type='checkbox'] {
            position: absolute;
            left: 20px;
            top: 22px;
            width: 18px;
            height: 18px;
            cursor: pointer;
            border: 1.5px solid #b9bbbe;
            margin-right: 6px;
          }
          .overlay-item-title {
            display: flex;
            align-items: center;
            padding-bottom: 20px;
            height: 44px;
            h3 {
              position: absolute;
              top: 23px;
              font-size: 14px;
              line-height: 20px;
              font-weight: 700;
              color: #2a2a2a;
              &.h3-checkbox-with {
                left: 44px;
              }
            }

            span {
              position: absolute;
              right: 20px;
              top: 23px;
              font-size: 14px;
              line-height: 20px;
              font-weight: 400;
              color: #676767;
            }
          }
          .overlay-item-content {
            display: flex;
            height: 70px;
            align-items: center;
            padding-bottom: 10px;
            position: relative;
            .content-img {
              width: 60px;
              height: 60px;
              border: 1px solid #dbdade;
              border-radius: 5px;
            }
            .img {
              position: absolute;
              top: 0;
              left: 0;
              width: 60px;
              height: 60px;
              overflow: hidden;
              border-radius: 5px;
              &.defaultImg {
                background: url(https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/default_shopping_img.png) no-repeat 0 0;
                background-size: 100% auto;
              }
              img {
                width: 100%;
                height: 100%;
              }
            }
            .overlay-item-checkbox {
              position: absolute;
              left: 70px;
              top: 0px;
            }
            input[type='checkbox'] {
              position: absolute;
              left: 72px;
              top: 2px;
              width: 18px;
              height: 18px;
              cursor: pointer;
              border: 1.5px solid #b9bbbe;
              margin-right: 6px;
            }
          }

          .overlay-item-content-with-radio {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }
          .overlay-item-desc {
            display: flex;
            flex-direction: column;
            margin-left: 78px;
            gap: 5px;
            &.overlay-item-desc-with-checkbox {
              margin-left: 98px;
            }
          }
          .overlay-item-button {
            display: flex;
            gap: 6px;
          }
        }
        .overlay-buttom-guide {
          display: flex;
          align-items: center;
          padding: 0px 20px;
          padding-bottom: 20px;
          span {
            margin-left: 5px;
            font-size: 12px;
            line-height: 100%;
            font-weight: 400;
            color: #676767;
          }
          i {
            color: #a8aaae;
          }
        }
        .overlay-footer {
          position: fixed;
          bottom: 0;
          display: flex;
          padding: 20px;
          gap: 10px;
          width: 410px;
          background-color: #fff;
          border-top: 1px solid #dbdade;
        }
      }
    }
  }
}
</style>
